
import { Link } from "react-router-dom";
import { InvenioLogo } from "@/components/ui/invenio-logo";

const MarketingFooter = () => {
  return (
    <footer className="bg-muted/30 border-t border-border">
      <div className="container mx-auto max-w-6xl px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <InvenioLogo className="h-8 w-auto text-primary" />
              <span className="font-bold text-xl text-foreground">InvenioCRM</span>
            </div>
            <p className="text-muted-foreground mb-4 max-w-md">
              AI-native recruitment platform that revolutionizes how recruiting agencies find, engage, and hire top talent with intelligent automation.
            </p>
            <p className="text-sm text-muted-foreground/80">
              © 2024 InvenioCRM. All rights reserved.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4 text-foreground">Product</h3>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/features" className="hover:text-foreground transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="hover:text-foreground transition-colors">Pricing</Link></li>
              <li><Link to="/integrations" className="hover:text-foreground transition-colors">Integrations</Link></li>
              <li><Link to="/api" className="hover:text-foreground transition-colors">API</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4 text-foreground">Company</h3>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/about" className="hover:text-foreground transition-colors">About</Link></li>
              <li><Link to="/careers" className="hover:text-foreground transition-colors">Careers</Link></li>
              <li><Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link></li>
              <li><Link to="/support" className="hover:text-foreground transition-colors">Support</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MarketingFooter;
